import { MarketProgram } from '@/features/bidding/constants'
import type {
  AggregateAvailability,
  AggregateAvailabilityResponse,
} from '@/features/bidding/types/aggregateAvailability'
import type { MarketDate } from '@/features/bidding/utils/date/marketDate'
import { ptusBetweenDates } from '@/features/bidding/utils/date/ptusBetweenDates'

// MW values per hour (0–23), range 5–60
// prettier-ignore
const FCRD_UP_AVAILABLE_MW =   [ 45, 38, 52, 60, 55, 42, 35, 48, 58, 40, 50, 36, 44, 53, 47, 39, 56, 41, 49, 60, 37, 51, 43, 54 ]
// prettier-ignore
const FCRD_DOWN_AVAILABLE_MW = [ 50, 42, 35, 55, 48, 60, 44, 38, 52, 46, 39, 57, 41, 53, 36, 49, 58, 43, 37, 54, 47, 40, 56, 45 ]
// prettier-ignore
const FCRN_AVAILABLE_MW =      [ 48, 55, 40, 52, 36, 58, 44, 60, 38, 50, 42, 35, 56, 47, 39, 53, 41, 57, 45, 37, 54, 43, 49, 60 ]

function buildAvailabilityFromValues(
  deliveryDay: MarketDate,
  marketProgram: MarketProgram,
  aggregateKey: string,
  mwValues: number[],
): AggregateAvailability {
  const startOfDay = deliveryDay.getStartOfDay()
  const endOfDay = deliveryDay.plus({ days: 1 }).getStartOfDay()
  const hours = ptusBetweenDates(startOfDay, endOfDay)

  return {
    aggregateKey,
    marketProgram,
    ptus: hours.slice(0, -1).map((start, index) => ({
      ptu: {
        start: start.toISO()!,
        end: start.plus({ hour: 1 }).toISO()!,
      },
      volume: {
        quantity: (mwValues[index] ?? 10) * 1_000_000,
        unit: 'WATTS',
      },
    })),
  }
}

export function buildAggregateAvailabilityFcrdResponse(deliveryDay: MarketDate): AggregateAvailabilityResponse {
  return {
    aggregationLevel: 'PRICE_AREA',
    availabilities: [
      buildAvailabilityFromValues(deliveryDay, MarketProgram.NORDICS_FCRD_UP_DYNAMIC, 'FI', FCRD_UP_AVAILABLE_MW),
      buildAvailabilityFromValues(deliveryDay, MarketProgram.NORDICS_FCRD_DOWN_DYNAMIC, 'FI', FCRD_DOWN_AVAILABLE_MW),
    ],
  }
}

export function buildAggregateAvailabilityFcrnResponse(deliveryDay: MarketDate): AggregateAvailabilityResponse {
  return {
    aggregationLevel: 'PRICE_AREA',
    availabilities: [buildAvailabilityFromValues(deliveryDay, MarketProgram.NORDICS_FCRN, 'FI', FCRN_AVAILABLE_MW)],
  }
}

export function buildAggregateAvailabilityResponse(deliveryDay: MarketDate): AggregateAvailabilityResponse {
  return buildAggregateAvailabilityFcrdResponse(deliveryDay)
}
